// =============================================================================
// SELF-TEST STORAGE SERVICE
// =============================================================================
//
// Opslag van self-test results in localStorage.
// Kan later naar Firebase worden uitgebreid indien nodig.
//
// =============================================================================

import { SelfTestResults } from './testDefinitions';

const STORAGE_KEY = 'self_test_results';

/**
 * Save self-test results to localStorage
 */
export function saveSelfTestResults(results: SelfTestResults): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(results));
  } catch (err) {
    console.warn('Failed to save self-test results:', err);
  }
}

/**
 * Load self-test results from localStorage
 */
export function loadSelfTestResults(): SelfTestResults | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    return JSON.parse(stored) as SelfTestResults;
  } catch (err) {
    console.warn('Failed to load self-test results:', err);
    return null;
  }
}

/**
 * Check if self-test results exist
 */
export function hasSelfTestResults(): boolean {
  return loadSelfTestResults() !== null;
}

/**
 * Clear self-test results
 */
export function clearSelfTestResults(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn('Failed to clear self-test results:', err);
  }
}
